import { isMobile, offsetOfElement } from '../lib/helpers'

const sections = new Set<InteractiveSection>()

addEventListener('DOMContentLoaded', () => {
	const onScroll = () => {
		const scrollEnd = scrollY + innerHeight

		for (const section of sections) {
			const offsetTop = offsetOfElement(section.element).offsetTop
			const offsetEnd = section.element.offsetHeight + offsetTop

			const topVisible = (scrollEnd - offsetTop) / innerHeight
			const bottomVisible = (offsetEnd - scrollY) / innerHeight

			const isVisible = topVisible >= section.threshold || bottomVisible <= section.threshold

			if (isVisible) {
				if (!section.visible) {
					section.visible = true
					section.becameVisible()

					if (!section.keepActive) {
						sections.delete(section)
					}
				}
			}
			else if (section.visible) {
				section.visible = false
				section.becameInvisible()
			}
		}
	}

	addEventListener('scroll', onScroll, { passive: true })
	addEventListener('load', onScroll)
})

/**
 * Checks whether its element is visible or not.
 */
export interface InteractiveSectionOptions {
	keepActive?: boolean
	threshold?: number
}

export default class InteractiveSection {
	public keepActive: boolean
	public threshold: number
	public offset: number
	public visible: boolean

	public constructor(
		public readonly element: HTMLElement,
		options: InteractiveSectionOptions = {}
	) {
		this.element = element

		this.keepActive = options.keepActive || false
		this.threshold = options.threshold || +element.getAttribute('data-observe-threshold') || 0
		if (isMobile()) {
			this.threshold *= 0.5
		}

		this.offset = 0
		this.visible = false

		sections.add(this)
	}

	public update(pageRange: [number, number]) {
		if (!this.element) {
			return
		}
	}

	public becameVisible() {
		this.visible = true
		this.element.classList.add('visible', 'initialized')
	}

	public becameInvisible() {
		this.visible = false
		this.element.classList.remove('visible')
	}
}